import { z } from 'zod';
export const ClientAvatar = z
    .object({
    version: z.number().int().nonnegative(),
    source: z.enum(['Instagram', 'Gravatar', 'Manual']).nullable(),
    status: z.enum(['Pending', 'Ready', 'Missing', 'Unavailable', 'Disabled']),
    checkedAt: z.iso.datetime().nullable(),
})
    .strict();
export const ClientAvatarMutation = z
    .object({ expectedVersion: z.number().int().nonnegative() })
    .strict();
export const ClientAvatarUpload = ClientAvatarMutation.extend({
    image: z.string().min(1).max(700_000),
}).strict();
export const ClientAvatarsResponse = z
    .object({ avatars: z.array(ClientAvatar.extend({ id: z.uuid() })).max(100) })
    .strict();
